import axiosInstance, { microServices } from 'network/apis/index'
import { SuccessMessage } from 'network/messageTranslationHelpers/messages'
import { METHOD_TYPES } from 'utils/constants/index'

export const placeBetCrashGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/galaxy-grab/place-bet', data, {
    server: microServices.USER_URL
    // successMessage: SuccessMessage.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/galaxy-grab/player-escape', data, {
    server: microServices.USER_URL
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/galaxy-grab/cancel-bet', data, {
    server: microServices.USER_URL,
    successMessage: SuccessMessage.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/galaxy-grab/get-history', {
    server: microServices.USER_URL
  })
}

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/galaxy-grab/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}
export const getPreviousRoundBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'game/crash/galaxy-grab/previous-round-placed-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/game/crash/galaxy-grab/top-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const verifyProvableFairCrashService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'game/crash/galaxy-grab/check-fairness', data, {
    server: microServices.USER_URL
  })
}
